module.exports = __webpack_public_path__ + "static/media/angle-double-left.529954b4.svg";